import config from './config.json'

export const REACT_APP_API_URL = config.REACT_APP_API_URL
export const REACT_APP_CLIENT_ID = config.REACT_APP_CLIENT_ID
export const REACT_HOST = config.REACT_HOST
